import GetStartedPanel from './container'
export default GetStartedPanel
